import BaseModel from '../base';

export default class Criterian extends BaseModel {
  constructor(criterian, url) {
    super(criterian, url);

    this.name = criterian.name;
    this.max_score = criterian.max_score;
    this.description = criterian.description;
    this.min_score = criterian.min_score || 1;
  }

  get putFormat() {
    const {
      name,
      min_score,
      max_score,
      description,
    } = this;

    return {
      name,
      min_score,
      max_score,
      description,
    };
  }
}
